import React from 'react';
import { motion } from 'framer-motion';
const characters = [{
  name: 'Marta',
  role: '52 años · Contadora Independiente',
  quote: 'Mis clientes me preguntan si ya uso IA en el estudio. Asiento, sonrío y cambio el tema... mientras por dentro rezo para que no me pidan una propuesta mañana.',
  result: '✓ Cerró el contrato más grande de su carrera sin ser experta.'
}, {
  name: 'Don Raúl',
  role: '58 años · Dueño de Taller Mecánico',
  quote: 'Llevo 40 años con mis manos debajo de los motores. Pero los papeles me están ganando. Siento que el taller va a cerrar conmigo.',
  result: '✓ Hoy lleva su taller con la IA. Los papeles ya no le ganan.'
}, {
  name: 'Carmen',
  role: '47 años · Maestra de Primaria',
  quote: 'Un alumno de 8 años le preguntó a ChatGPT si yo sabía usar IA. La respuesta fue que no. Me lo dejó escrito en el pizarrón.',
  result: '✓ Hoy dirige el proyecto piloto de IA de su distrito escolar.'
}, {
  name: 'Lucía',
  role: '61 años · Enfermera Jubilada',
  quote: 'Mis nietos no se sientan conmigo a comer. No quiero aprender tecnología. Solo quiero un pretexto para que vuelvan a mi mesa los sábados.',
  result: '✓ Abrió un negocio digital con su nieta de 16 años.'
}, {
  name: 'Jorge',
  role: '49 años · Gerente de Ventas',
  quote: 'Llevo 18 años en la misma empresa. Veo a los de 25 avanzar con herramientas que yo no sé nombrar. Siento que se me acaba el tiempo.',
  result: '✓ Renunció. Montó su propio negocio con su esposa. Factura más.'
}, {
  name: 'Andrés',
  role: '39 años · Ingeniero Civil',
  quote: 'Me da vergüenza admitir que el pasante hace en una tarde lo que a mí me toma tres días. Tengo una reputación que proteger.',
  result: '✓ Ganó la licitación más grande de su carrera usando IA con método de ingeniero.'
}];
export function CharactersGrid() {
  return <section className="w-full bg-crema pt-6 md:pt-10 pb-14 md:pb-[88px] px-6 lg:px-12" data-id="element-33">
      <div className="max-w-[1100px] mx-auto" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-35">
          <h2 className="text-[32px] font-serif font-bold text-navy" data-id="element-36">
            Conoce a las 6 personas que se sentaron antes que tú
          </h2>
          <p className="text-base font-sans text-[#666666] max-w-[520px] mx-auto mt-3" data-id="element-37">
            Sus historias son reales. Sus miedos, probablemente, también son los
            tuyos.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1
      }} className="w-full mb-12 rounded-2xl overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)]" data-id="element-38">
          <img src="https://cdn.magicpatterns.com/uploads/orErZAgE4fab5gbUNr4MVo/Foto_Mesa_Final_-_Cap08-1.png" alt="La Mesa Redonda — 6 personas reales conversando" className="w-full h-auto object-cover max-h-[480px]" data-id="element-39" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-40">
          {characters.map((char, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-white rounded-xl p-7 border-l-4 border-gold shadow-[0_2px_16px_rgba(0,0,0,0.06)] hover:-translate-y-1 hover:shadow-[0_8px_24px_rgba(0,0,0,0.12)] transition-all duration-300 flex flex-col" data-id="element-41">
              <h3 className="text-xl font-serif font-bold text-navy" data-id="element-42">
                {char.name}
              </h3>
              <p className="text-[11px] font-sans font-bold text-gold uppercase tracking-wider mb-3.5" data-id="element-43">
                {char.role}
              </p>
              <p className="text-[14px] font-sans italic text-[#4A4A4A] leading-[1.75] flex-grow" data-id="element-44">
                "{char.quote}"
              </p>
              <p className="text-[13px] font-sans font-bold text-[#27AE60] mt-4" data-id="element-45">
                {char.result}
              </p>
            </motion.div>)}
        </div>

        <div className="flex justify-center mt-12" data-id="element-46">
          <motion.a href="#offer" whileHover={{
          scale: 1.02,
          filter: 'brightness(0.92)'
        }} whileTap={{
          scale: 0.98
        }} className="bg-burnt text-white font-sans font-bold text-[17px] rounded-lg py-[18px] px-[44px] shadow-[0_4px_20px_rgba(230,126,34,0.35)] transition-all duration-200 w-full sm:w-auto inline-block text-center no-underline" data-id="element-47">
            Sí, quiero sentarme a la mesa — $12.97 &rarr;
          </motion.a>
        </div>
      </div>
    </section>;
}